<div class="page-container">
  <div class="page-header">
    <div>
      <p class="greeting-title">{{greetingTitle}}</p>
      <h1 class="page-title">Dashboard</h1>
    </div>
    <button class="streak" (click)="showStreak()">
      <i class="fas fa-fire"></i>{{user?.numberOfStreakDays}} Tage
    </button>
  </div>

  <app-repetition-count-widget [showButtonToSmartRepetition]="true"></app-repetition-count-widget>

  <div *ngIf="courses" class="courses">
    <span>Deine Ordner</span>
    <app-courses-list *ngIf="courses && courses!.length > 0" [courses]="courses!" (courseClicked)="openCourse($event)"></app-courses-list>
  </div>

  <app-bottom-dialog [title]="'Dein Streak'" [isVisible]="showStreakDialog" (actionCancelled)="showStreakDialog = false">
    <app-streak [streakNumber]="user?.numberOfStreakDays" [days]="user?.currentWeekActivity"></app-streak>
  </app-bottom-dialog>
</div>